export const getAuth = state => state.auth

export const getCustomer = state => state.customer

export const getUnit = state => state.unit
